/* Real Food · PDP · carrusel automatico de iconos en mobile */
(function () {
  var MX = 768;    /* breakpoint mobile */
  var STEP = 2000; /* cada cuanto avanza */
  var HOLD = 5000; /* pausa tras deslizar el usuario */
  var VIS = 3;     /* iconos visibles a la vez */

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mob() { return window.innerWidth <= MX; }
  function rows() { return document.querySelectorAll('[id^="ProductPageWrapper-"] [class*="icons-row-"]'); }

  function off(r) {
    var s = r.__rf; if (!s) return;
    clearInterval(s.t); if (s.io) s.io.disconnect();
    r.removeEventListener('scroll', s.sc);
    s.it.forEach(function (e) { e.style.flex = ''; e.style.width = ''; e.style.maxWidth = ''; });
    if (s.d && s.d.parentNode) s.d.parentNode.removeChild(s.d);
    r.scrollLeft = 0; r.__rf = null;
  }

  function on(r) {
    var it = Array.prototype.filter.call(r.children, function (n) { return n.nodeType === 1; });
    if (it.length <= VIS) return;

    function gap() { var c = getComputedStyle(r); return parseFloat(c.columnGap) || parseFloat(c.gap) || 0; }
    function step() {
      var v = it[1].offsetLeft - it[0].offsetLeft;
      if (v > 10) return v;
      var g = gap();
      return (r.clientWidth - g * (VIS - 1)) / VIS + g;
    }

    var g0 = gap();
    it.forEach(function (e) {
      e.style.flex = '0 0 calc((100% - ' + (g0 * (VIS - 1)) + 'px) / ' + VIS + ')';
      e.style.width = 'auto';
      e.style.maxWidth = 'none';
    });

    var pg = it.length - VIS + 1;
    var d = document.createElement('div');
    d.className = 'rf-dots';
    for (var i = 0; i < pg; i++) d.appendChild(document.createElement('i'));
    if (r.parentNode) r.parentNode.insertBefore(d, r.nextSibling);

    var s = { i: 0, h: 0, t: null, io: null, it: it, d: d, vis: true };

    function paint() { for (var k = 0; k < d.children.length; k++) d.children[k].className = (k === s.i ? 'on' : ''); }
    function go(k) {
      var st = step(); if (!(st > 10)) return;
      s.i = ((k % pg) + pg) % pg;
      var L = Math.round(s.i * st);
      if (r.scrollTo) r.scrollTo({ left: L, behavior: 'smooth' }); else r.scrollLeft = L;
      paint();
    }
    function tick() { if (Date.now() < s.h || document.hidden || !s.vis) return; go(s.i + 1); }
    function hold() { s.h = Date.now() + HOLD; }

    s.sc = function () {
      var st = step(); if (!(st > 10)) return;
      var k = Math.round(r.scrollLeft / st);
      if (k !== s.i && k >= 0 && k < pg) { s.i = k; paint(); }
    };

    r.addEventListener('pointerdown', hold);
    r.addEventListener('touchstart', hold, { passive: true });
    r.addEventListener('wheel', hold, { passive: true });
    r.addEventListener('scroll', s.sc, { passive: true });

    if (window.IntersectionObserver) {
      s.io = new IntersectionObserver(function (e) { s.vis = e[0].isIntersecting; }, { threshold: 0.2 });
      s.io.observe(r);
    }
    if (!RM) s.t = setInterval(tick, STEP);

    r.__rf = s; paint();
  }

  function scan() {
    Array.prototype.forEach.call(rows(), function (r) { if (mob()) { if (!r.__rf) on(r); } else off(r); });
  }
  function redo() { Array.prototype.forEach.call(rows(), off); scan(); }

  var tm;
  window.addEventListener('resize', function () { clearTimeout(tm); tm = setTimeout(redo, 250); });
  window.addEventListener('orientationchange', function () { clearTimeout(tm); tm = setTimeout(redo, 350); });
  document.addEventListener('shopify:section:load', redo);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
})();
